var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("administration.company_add") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "pb-3 no-gutters" },
            [_c("back-button", { attrs: { returnUrl: _vm.returnUrl } })],
            1
          ),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("administration.company"),
                isTitleUpperCase: false,
              },
            },
            [
              _c("div", { staticClass: "form-group" }),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("administration.identifier"),
                          placeholderValue: _vm.$t("administration.identifier"),
                        },
                        model: {
                          value: _vm.identifier,
                          callback: function ($$v) {
                            _vm.identifier = $$v
                          },
                          expression: "identifier",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("administration.company_name"),
                          placeholderValue: _vm.$t(
                            "administration.company_name"
                          ),
                        },
                        model: {
                          value: _vm.name,
                          callback: function ($$v) {
                            _vm.name = $$v
                          },
                          expression: "name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("administration.user_email"),
                          placeholderValue: _vm.$t("administration.user_email"),
                        },
                        model: {
                          value: _vm.email_reference,
                          callback: function ($$v) {
                            _vm.email_reference = $$v
                          },
                          expression: "email_reference",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("label", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("administration.active")) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.active,
                              expression: "active",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { id: "sel4", readonly: "" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.active = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "0" } }, [
                            _vm._v(
                              " " + _vm._s(_vm.$t("administration.no")) + " "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "1" } }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("administration.in_prgrss")) +
                                " "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "2" } }, [
                            _vm._v(
                              " " + _vm._s(_vm.$t("administration.yes")) + " "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("administration.user"),
                isTitleUpperCase: false,
              },
            },
            [
              _c("div", { staticClass: "form-group" }),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("administration.login"),
                          placeholderValue: _vm.$t("administration.login"),
                        },
                        model: {
                          value: _vm.login,
                          callback: function ($$v) {
                            _vm.login = $$v
                          },
                          expression: "login",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("administration.username"),
                          placeholderValue: _vm.$t("administration.username"),
                        },
                        model: {
                          value: _vm.username,
                          callback: function ($$v) {
                            _vm.username = $$v
                          },
                          expression: "username",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("label", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("administration.active")) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.active_user,
                              expression: "active_user",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { id: "sel4", readonly: "" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.active_user = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "0" } }, [
                            _vm._v(
                              " " + _vm._s(_vm.$t("administration.no")) + " "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "1" } }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("administration.in_prgrss")) +
                                " "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "2" } }, [
                            _vm._v(
                              " " + _vm._s(_vm.$t("administration.yes")) + " "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("administration.password"),
                          inputType: "password",
                          placeholderValue: _vm.$t("administration.password"),
                        },
                        model: {
                          value: _vm.password,
                          callback: function ($$v) {
                            _vm.password = $$v
                          },
                          expression: "password",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("administration.right"),
                isTitleUpperCase: false,
              },
            },
            [
              _c("div", { staticClass: "form-group" }),
              _vm._v(" "),
              _c(
                "b-row",
                _vm._l(_vm.rights, function (result, id) {
                  return _c(
                    "b-col",
                    {
                      key: result + "-" + id,
                      staticClass: "form-group",
                      attrs: { sm: "6", lg: "4", xl: "3" },
                    },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          attrs: { value: result },
                          model: {
                            value: _vm.select_rights,
                            callback: function ($$v) {
                              _vm.select_rights = $$v
                            },
                            expression: "select_rights",
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("rights.db_rights." + result) ===
                                  "rights.db_rights." + result
                                  ? result
                                  : _vm.$t("rights.db_rights." + result)
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            {
              staticClass:
                "accordionForm form-group mt-3 justify-content-end no-gutters",
            },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.createCompany()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa-light fa-save" }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }